import { useNavigate } from 'react-router-dom'
import styles from './Dashboard.module.scss'

import ArrowIcon from 'Icons/arrow-right.svg'
import HappyFoxLogo from 'Logos/happyfox.svg'
import CalendlyLogo from 'Logos/calendly.svg'
import ZapierLogo from '../../../pages/protected/Apps/brand/zapier.svg'

import { useGetMyDataQuery } from 'Services/me'

const QUICK_NAVS = [
  {
    id: 1,
    title: 'Add Content',
    description: 'Add some answers and guides or link your existing knowledge base',
    action_name: 'Add',
    path: 'content'
  },
  {
    id: 2,
    title: 'Customize Bots',
    description: 'Customize the bot with your own phrases and flows',
    action_name: 'Start',
    path: 'bots'
  },
  {
    id: 3,
    title: 'Setup Widget Appearance',
    description: 'Customize the bot widget with your own theme color and logo',
    action_name: 'Start',
    path: 'settings/appearance'
  },
  {
    id: 4,
    title: 'Widget Installation',
    description: 'Install the bot widget on your website',
    action_name: 'Install',
    path: 'settings/installation'
  }
]

const APPS = [
  {
    app_type: 'happyfox_helpdesk',
    name: 'HappyFox Help Desk',
    brandImage: <HappyFoxLogo width='28' height='28' />
  },
  {
    app_type: 'happyfox_workflows',
    name: 'HappyFox Workflows',
    brandImage: <HappyFoxLogo width='28' height='28' />
  },
  {
    app_type: 'calendly',
    name: 'Calendly',
    brandImage: <CalendlyLogo width='28' height='28' />
  },
  {
    app_type: 'zapier',
    name: 'Zapier',
    brandImage: <ZapierLogo width='28' height='28' />
  }
]

const Dashboard = () => {
  const navigate = useNavigate()
  const { data: user } = useGetMyDataQuery()

  const onClickQuickNav = (path) => {
    navigate(`/b/${path}`)
  }

  const onClickApp = (appName) => {
    if (appName) {
      navigate(`/b/apps/${appName}`)
    } else {
      navigate('/b/apps')
    }
  }

  return (
    <div className={styles.DashboardContainer}>
      <div className={styles.LeftSection}>
        <div className={styles.WelcomeText}>
          Welcome <br /> <span className={styles.UserName}> {user?.name}! </span>
        </div>
        <div className={styles.BotIdeasAction}>
          <div className={styles.VideoContainer} />
          <div className={styles.ActionContainer} />
        </div>
      </div>
      <div className={styles.RightSection}>
        <div className={styles.AddContentSection}>
          <div className={styles.AddContentHeader}>
            <span> Let’s get Chatbot up and running! </span>
          </div>
          <div className={styles.AddContentContainer}>
            {QUICK_NAVS.map((item) => {
              return (
                <div key={item.id} className={styles.AddContentCard}>
                  <div className={styles.ContentLabelContainer}>
                    <label className={styles.Title}> {item.title} </label>
                    <label className={styles.Description}> {item.description} </label>
                  </div>
                  <div className={styles.ActionsContainer}>
                    <button className={styles.QuickNavBtn} onClick={() => onClickQuickNav(item.path)}>
                      <span> {item.action_name} </span>
                      <ArrowIcon width='18' height='18' />
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className={styles.AddAppsSection}>
          <label className={styles.AddAppsSectionLabel}>
            Apps we recommend
            <a className={styles.ViewAllApps} onClick={onClickApp}>
              View all apps
            </a>
          </label>
          <div className={styles.AppsContainer}>
            {APPS.map((app) => {
              return (
                <div key={app.app_type} className={styles.AppCard} onClick={() => onClickApp(app.app_type)}>
                  {app.brandImage}
                  <label className={styles.AppText}> {app.name} </label>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
